export function submitHubspotForm({
  portalId,
  formId,
  fields,
  context,
}: {
  portalId: string
  formId: string
  fields: Array<{ name: string; value: string }>
  context: {
    pageUri: string
    pageName: string
  }
}) {
  return fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      fields,
      context,
    }),
  })
}
